import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

import { meQueryOptions } from '@/api/queries'
import { ApiError } from '@/api/client'
import { AppShell } from '@/components/layout/app-shell'
import { canOpenDashboard } from '@/shared/permissions'

/**
 * Guard всех защищённых экранов. Профиль запрашивается до отрисовки: токена в JS
 * нет, единственный способ узнать, есть ли сессия, — спросить бэкенд по куке.
 */
export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ context, location }) => {
    try {
      const me = await context.queryClient.ensureQueryData(meQueryOptions)
      if (!canOpenDashboard(me.role)) {
        throw redirect({ to: '/login', search: { error: 'forbidden_role' } })
      }
      return { me }
    } catch (error) {
      if (error instanceof ApiError && error.isUnauthorized) {
        throw redirect({ to: '/login', search: { redirect: location.href } })
      }
      throw error
    }
  },
  component: AuthLayout,
})

function AuthLayout() {
  const { me } = Route.useRouteContext()
  return (
    <AppShell user={me}>
      <Outlet />
    </AppShell>
  )
}
